export default function checkIfEcheancierWithoutEcheanceFacturer(echeancier) {
  if (echeancier.echeancierLignes.length === 0) return true;
  return echeancier.echeancierLignes.some((echeancierLigne) => {
    return !echeancierLigne.facturationFaite;
  });
}
